import route from '@/router/index'
import {ACCESS_TOKEN_NAME, AUTHORRITIES_NAME, USER_NAME} from '@/constant'
import securityCfg from '@/security/config'

const security = (function (router) {
  let userName
  let timeoutOTP
  let authorities
  let authorizationMapper
  let authenSuccesUrlRedirect
  let playStatus

  let initAuthorities = function () {
    let authoritiesStore = getAuthoritiesStore()
    authorities = new Map()
    for (let element of authoritiesStore) {
      let author = element.authority
      authorities.set(author, author)
    }
  }

  let initAuthorizationMapper = function () {
    authorizationMapper = []
    cloneObjConfig(securityCfg.authorizationMapper, authorizationMapper)
  }

  let initAuthenSuccesUrlRedirect = function () {
    authenSuccesUrlRedirect = securityCfg.authenSuccesUrlRedirect(hasAuthor)
  }

  let initConfig = function () {
    initAuthorizationMapper()
    initAuthenSuccesUrlRedirect()
  }

  let initRouteFilter = function () {
    router.beforeEach((to, from, next) => {
      let _isLogin = isLogin()
      let _fullPath = to.fullPath
      let _isAuthorized = isAuthorized(_fullPath)
      if (!_isLogin && _fullPath === '/') {
        next()
      } else if (_isLogin && (_fullPath === '/')) {
        next(authenSuccesUrlRedirect)
      } else if (_isAuthorized) {
        next()
      } else if (!_isLogin) {
        next({name: 'Home'})
      } else {
        next({name: 'page403'})
      }
    })
  }

  let cloneObjConfig = function (origin, target) {
    for (let attr in origin) {
      target[attr] = origin[attr]
    }
  }

  let isLogin = function () {
    return authorities && authorities.size
  }

  let hasAuthor = function (author) {
    return authorities.has(author)
  }

  let isAuthorized = function (path) {
    let _isAuthorized = true
    for (let authorCfg of authorizationMapper) {
      if (!(authorCfg.regex instanceof RegExp)) {
        continue
      }
      if (authorCfg.regex.test(path) && typeof authorCfg.isAuthorized === 'function') {
        _isAuthorized &= authorCfg.isAuthorized(hasAuthor)
      }
    }
    return _isAuthorized
  }

  let authLogin = function (access_token, authoritiesStore, userName) {
    localStorage.setItem(ACCESS_TOKEN_NAME, access_token)
    localStorage.setItem(AUTHORRITIES_NAME, JSON.stringify(authoritiesStore))
    localStorage.setItem(USER_NAME, userName)
    initAuthorities()
    setupUserInfor()
    initAuthenSuccesUrlRedirect()
    route.push(authenSuccesUrlRedirect)
  }

  let authLogout = function () {
    authorities.clear()
    localStorage.clear()
    route.push({path: '/'}).catch(err => {
    })
  }

  let getAuthoritiesStore = function () {
    let authoritiesStore
    try {
      let _authoritiesStr = localStorage.getItem(AUTHORRITIES_NAME)
      if (_authoritiesStr) {
        authoritiesStore = JSON.parse(_authoritiesStr)
      } else {
        authoritiesStore = []
      }
    } catch (e) {
      authoritiesStore = []
    }
    return authoritiesStore
  }

  let setTimeoutOtp = function (time) {
    timeoutOTP = localStorage.setItem(TIMEOUT_OTP, time)
  }

  let getTimeoutOtp = function () {
    return localStorage.getItem(TIMEOUT_OTP)
  }

  let getUserName = function () {
    return userName
  }

  let setupUserInfor = function () {
    userName = localStorage.getItem(USER_NAME)
  }

  let setPlayStatus = function (status) {
    playStatus = status
  }
  let getPlayStatus = function () {
    return playStatus
  }

  let init = function () {
    initAuthorities()
    initConfig()
    setupUserInfor()
    initRouteFilter()
  }

  init()

  return {
    roles: securityCfg.roles,
    getUserName: getUserName,
    setTimeoutOtp: setTimeoutOtp,
    getTimeoutOtp: getTimeoutOtp,
    hasAuthor: hasAuthor,
    isAuthorized: isAuthorized,
    isLogin: isLogin,
    authLogin: authLogin,
    authLogout: authLogout,
    setPlayStatus: setPlayStatus,
  }
})(route)

export function setPlayStatus (status) {
  return security.setPlayStatus(status)
}

export function roles () {
  return security.roles
}

export function getUserName () {
  return security.getUserName()
}

export function getTimeoutOtp () {
  return security.getTimeoutOtp()
}

export function setTimeoutOtp (time) {
  return security.setTimeoutOtp(time)
}

export function hasAuthor (author) {
  return security.hasAuthor(author)
}

export function isAuthorized (path) {
  return security.isAuthorized(path)
}

export function authLogin (access_token, authoritiesStore, userName) {
  return security.authLogin(access_token, authoritiesStore, userName)
}

export function authLogout () {
  return security.authLogout()
}




// WEBPACK FOOTER //
// ./src/security/index.js